import ToastWrapper from './ToastWrapper.vue'

export default ToastWrapper
